import React from 'react';
import classnames from 'classnames';
import Radio from '../../../components/form/Radio';
var MembershipOption = function(param) {
    var priceId = param.priceId, onChange = param.onChange, noMembership = param.noMembership, isSelected = param.isSelected, label = param.label, extraText = param.extraText;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('MembershipOption position-relative', {
            isSelected: isSelected,
            noMembership: noMembership
        })
    }, /*#__PURE__*/ React.createElement(Radio, {
        id: priceId,
        onChange: onChange,
        value: priceId,
        checked: isSelected
    }), /*#__PURE__*/ React.createElement("label", {
        htmlFor: priceId,
        className: "label"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "label"
    }, label), /*#__PURE__*/ React.createElement("div", {
        className: "extraText"
    }, extraText)));
};
export default MembershipOption;
